const BrochureOption1 = {
    "AL": "AL$~B40175AL",
    "AK": "AK$~B40175NAK",
    "AR": "AR$~B40175AR",
    "AZ": "AZ$~B40175NAZ",
    "CA": "CA$~B40175CA",
    "CO": "CO$~B40175NCOR",
    "CT": "CT$~B40175CT",
    "DC": "DC$~B40175NDC",
    "DE": "DE$~B40175DE",
    "FL": "FL$~B40175FL",
    "GA": "GA$~B40175GA",
    "HI": "HI$~B40175HI",
    "IA": "IA$~B40175IA",
    "ID": "ID$~B40175ID",
    "IL": "IL$~B40175IL",
    "IN": "IN$~B40175NIN",
    "KS": "KS$~B40175KS",
    "KY": "KY$~B40175NKY",
    "LA": "LA$~B40175NLA",
    "MA": "MA$~B40175MA",
    "MD": "MD$~B40175NMDR",
    "ME": "ME$~B40175ME",
    "MI": "MI$~B40175NMI",
    "MN": "MN$~B40175NMN",
    "MS": "MS$~B40175NMS",
    "MO": "MO$~B40175NMO",
    "MT": "MT$~B40175MT",
    "NC": "NC$~B40175NNC",
    "ND": "ND$~B40175NND",
    "NE": "NE$~B40175NNE",
    "NM": "NM$~B40175NNM",
    "NV": "NV$~B40175NV",
    "NY": "NY$~NYB40175R",
    "OH": "OH$~B40175NOH",
    "OK": "OK$~B40175OK",
    "OR": "OR$~B40175OR",
    "PA": "PA$~B40175PA",
    "SC": "SC$~B40175SCR",
    "SD": "SD$~B40175NSD",
    "TN": "TN$~B40175NTN",
    "TX": "TX$~B40175TX",
    "UT": "UT$~B40175UT",
    "VI": "VI$~B40175NVI",
    "VT": "VT$~B40175VT",
    "WI": "WI$~B40175WI",
    "WV": "WV$~B40175WV",
    "WY": "WY$~B40175NRWY",
};

const BrochureOptionH = {
    "AK": "AK$~B40175HNAK",
    "AR": "AR$~B40175HAR",
    "AZ": "AZ$~B40175HNAZ",
    "CA": "CA$~B40175HCA",
    "CO": "CO$~B40175HNCOR",
    "CT": "CT$~B40175HCT",
    "DC": "DC$~B40175HNDC",
    "DE": "DE$~B40175HDE",
    "FL": "FL$~B40175HFL",
    "GA": "GA$~B40175HGA",
    "HI": "HI$~B40175HHI",
    "IA": "IA$~B40175HIA",
    "ID": "ID$~B40175HID",
    "IL": "IL$~B40175HIL",
    "IN": "IN$~B40175HNIN",
    "KS": "KS$~B40175HKS",
    "KY": "KY$~B40175HNKY",
    "LA": "LA$~B40175HNLA",
    "MA": "MA$~B40175HMA",
    "MD": "MD$~B40175HNMDR",
    "ME": "ME$~B40175HME",
    "MI": "MI$~B40175HNMI",
    "MN": "MN$~B40175HNMN",
    "MO": "MO$~B40175HNMO",
    "MT": "MT$~B40175HMT",
    "NC": "NC$~B40175HNNC",
    "ND": "ND$~B40175HNND",
    "NE": "NE$~B40175HNNE",
    "NM": "NM$~B40175HNNM",
    "NV": "NV$~B40175HNV",
    "NY": "NY$~NYB40175H",
    "OH": "OH$~B40175HNOH",
    "OK": "OK$~B40175HOK",
    "OR": "OR$~B40175HOR",
    "PA": "PA$~B40175HPA",
    "SC": "SC$~B40175HSCR",
    "SD": "SD$~B40175HNSD",
    "TN": "TN$~B40175HNTN",
    "TX": "TX$~B40175HTX",
    "UT": "UT$~B40175HUT",
    "VI": "VI$~B40175HNVI",
    "VT": "VT$~B40175HVT",
    "WI": "WI$~B40175HWI",
    "WV": "WV$~B40175HWV",
    "WY": "WY$~B40175HNRWY",
}
const BrochureOptionMedicareGuide = {
    "WI": "WI$_2022 Wisconsin Medicare Guide",
};

const BrochureOptionMedicareGuideStateWise = {
    "MA": "MA$_2022 Massachusetts Medicare Guide",
};
export function getBrochure(isHSA, state) {
    const Option1Default = "GEN$~B40175N";
    const OptionsHDefault = "GEN$~B40175HN";
    var brochure;
    var option;
    if (isHSA) {
        brochure = BrochureOptionH[state];
        option = "Brochure Option H";
        if (!brochure) {
            brochure = OptionsHDefault;
        }    
    }else {
        brochure = BrochureOption1[state];
        option = "Brochure Option 1";
        if (!brochure) {
            brochure = Option1Default;
        }
    }

    return {
        option: option,
        filename: brochure
    }    
}
export function getMedicareGuideBrochure(state) {
    const MedicareGuideDefault = "GEN$_2022 Standard Medicare Guide";
    var brochure = BrochureOptionMedicareGuide[state];
    if (!brochure) {
        brochure = MedicareGuideDefault;
    }

    return {
        option: "Medicare Guide",
        filename: brochure,
    }
}

export function getStateSpecificMedicareGuideBrochure(state) {
    var brochure = BrochureOptionMedicareGuideStateWise[state];

    return {
        option: "Medicare Guide",
        filename: brochure,
    }
}
